import {FlowContextStore} from '../stores';
import {inject, Injectable, signal} from '@angular/core';
import {Params} from '@angular/router';
import {customerReturnUrl} from '../utils/return-url';

@Injectable({providedIn:'root'})
export class LoginRequestService {
  private readonly flow = inject(FlowContextStore);
  readonly pending = signal<{returnUrl:string; queryParams:Params} | null>(null);
  request(returnUrl:string, queryParams:Params = {}): void {
    this.pending.set({returnUrl:customerReturnUrl(returnUrl), queryParams});
  }
  dismiss(): void { this.pending.set(null); this.flow.setContext({returnUrl:null, autoGenerateCoupon:false, autoEnterSweepstakes:false}); }
  complete(): void { this.pending.set(null); }
}
